import type { PlanningServiceKey } from '../../../config';

/**
 * Mapping entre les types de bâtiments et les IDs de services
 * Basé sur la structure de la base de données:
 * - id 1: 'Police'
 * - id 2: 'Pompiers'
 * - id 3: 'SAMU'
 * - id 4: 'Gendarmerie'
 */

/**
 * Convertit un type de bâtiment en ID de service
 * @param buildingType Type de bâtiment ('pompier', 'hopital', 'fdo', 'prison')
 * @returns ID du service correspondant, ou null si le type n'est pas reconnu
 */
export function getServiceIdFromBuildingType(buildingType: string): number | null {
  switch (buildingType) {
    case 'pompier':
      return 2; // Pompiers
    case 'hopital':
      return 3; // SAMU
    case 'fdo':
      return 1; // Police
    case 'prison':
      return 1; // Police (gestion des prisonniers)
    default:
      return null;
  }
}

/**
 * Clé `statuts_planning` / `statuts_planning_by_service` pour le type de bâtiment courant.
 */
export function getPlanningServiceKeyFromBuildingType(buildingType: string): PlanningServiceKey | null {
  switch (buildingType) {
    case 'pompier':
      return 'Pompiers';
    case 'hopital':
      return 'SAMU';
    case 'fdo':
    case 'prison':
      return 'FDO';
    default:
      return null;
  }
}

